import React, { useMemo } from 'react';

export function ProductCard ({ product, detail }) 
{
  const dateChecker = useMemo(() => {
    if (!product?.updatedAt) return false;

    const productDate = new Date(product.updatedAt);
    const now = new Date();
    const diffInMs = now - productDate;
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

    return diffInDays <= 5;
  }, [product]);  

  return (
    <div className="col-xl-3 col-md-6 col-sm-6 col-lg-4 mb-4">
      <div className="product-card border">
        {/* Badge Diagonale (New/Sale) */}
        { dateChecker && (
          <div className={`badge-corner new`}>
            <span> New </span>
          </div>
        )}
        {/* Image & Overlay Actions au Hover */}
        <div className="product-image-wrapper">
          <img src={ product?.images[0]?.url } alt={product?.name} className="img-fluid" />
        </div>
        {/* Infos Produit */}
        <div className="product-info my-3 px-3">
          <div className="d-flex justify-content-between align-items-start">
            <div>
              <h6 className="product-name text-truncate" style={{maxWidth: '150px'}}>
                {product?.name}
              </h6>
              <div className="stars">
                {[...Array(product?.starCount)].map((_, i) => (
                  <i key={i} className="bi bi-star-fill me-1"></i>
                ))}
              </div>

              <div className="d-flex justify-content-between align-items-center">
                <span className="price-current"> { product?.price + " " + product?.currency } </span>
              </div>

              <button title="Plus d'informations" className="btn btn-sm rounded-0 btn-outline-green px-3 mt-2" onClick={ detail }>
                 Details <i className="bi bi-chevron-right"></i> 
              </button>

            </div>
            
          </div>
        </div>
      </div>
    </div>
  );
};


export function ServiceCard ({ icon, title, description }) 
{
  return (
    <div className="col-12 col-sm-6 col-lg-3 mb-4 mb-lg-0">
      <div className="d-flex align-items-center justify-content-center justify-content-lg-start service-item border p-3">
        <div className="service-icon me-3">
          <i className={`bi ${icon}`} style={{ fontSize: '2rem', color: 'text-dark'  }}></i>
        </div>
        <div className="service-text">
          <h6 className="fw-bold mb-0 text-uppercase text-dark" style={{ fontSize: '0.9rem', letterSpacing: '0.5px' }}>
            {title}
          </h6>
          <p className="text-dark mb-0" style={{ fontSize: '0.85rem' }}>
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};



export function TextReducer({text, maxsize}) 
{
    if ( text?.length <= maxsize )
     return ( <span > { text }  </span> )
    else{
        const reducer = text?.slice(0, maxsize) + '...';
        return ( <span > { reducer }  </span> )
    }
}






// Skeleton Loader pour ProductCard
export function ProductCardSkeleton () {

  return (
  <div className="col-xl-3 col-md-6 col-sm-6 col-lg-4 mb-4">
    <div className="product-card border">
      {/* Image Skeleton */}
      <div className="product-image-wrapper">
        <div 
          style={{
            width: '100%',
            paddingBottom: '100%',
            backgroundColor: '#e0e0e0',
            position: 'relative',
            animation: 'pulse 2s ease-in-out infinite'
          }}
        />
      </div>
      {/* Infos Skeleton */}
      <div className="product-info my-3 px-3">
        <div className="d-flex justify-content-between align-items-start">
          <div style={{ width: '100%' }}>
            {/* Titre Skeleton */}
            <div 
              style={{
                height: '16px',
                backgroundColor: '#e0e0e0',
                marginBottom: '10px',
                borderRadius: '4px',
                width: '80%',
                animation: 'pulse 2s ease-in-out infinite'
              }}
            />
            {/* Stars Skeleton */}
            <div 
              style={{
                height: '16px',
                backgroundColor: '#e0e0e0',
                marginBottom: '10px',
                borderRadius: '4px',
                width: '70%',
                animation: 'pulse 2s ease-in-out infinite'
              }}
            />
            {/* Prix Skeleton */}
            <div 
              style={{
                height: '18px',
                backgroundColor: '#e0e0e0',
                marginBottom: '10px',
                borderRadius: '4px',
                width: '50%',
                animation: 'pulse 2s ease-in-out infinite'
              }}
            />
            {/* Bouton Skeleton */}
            <div 
              style={{
                height: '36px',
                backgroundColor: '#e0e0e0',
                marginTop: '8px',
                borderRadius: '4px',
                width: '100%',
                animation: 'pulse 2s ease-in-out infinite'
              }}
            />
          </div>
        </div>
      </div>
    </div>
    <style>{`
      @keyframes pulse {
        0% {
          opacity: 1;
        }
        50% {
          opacity: 0.5;
        }
        100% {
          opacity: 1;
        }
      }
    `}</style>
  </div>
);
}
